import { Icon } from "@fluentui/react";
import React, { useContext } from "react";
import { ACTIONS } from "../../constants/Constants";
import themeContext from "../../context/theme/ThemeContext";

const CustomTab = (props) => {
  const { getThemeColor } = useContext(themeContext);
    return (
        <div
        style={{
          padding: "10px",
          display: "flex",
          justifyContent: "space-between",
          alignItems:'center'
  
        }}
      >
        <div style={{ display: "flex" }}>
          <p
            style={{
              margin: "0px",
              padding: "10px 28px 10px 10px",
              width: "56px",
              boxSizing: "border-box",
              textAlign: "start",
              fontSize: "16px",
              fontWeight: "400",
              color: getThemeColor("primary-color")
            }}
          >
           {props.orderNumber}
          </p>
          <div style={{display:'flex', flexDirection:'column', margin: "0px 10px",justifyContent:'center'}}>
          <p
            style={{
              padding: "0px",
              fontSize: "16px",
              fontWeight: "600",
              textAlign: "start"
              // lineHeight: "42px",
            }}
          >
           {props.tabName}
          </p>
          {props.subtitle != null && props != undefined &&<p
           className="tab-container-subtitle"
          >{props.subtitle}</p>}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            marginRight:'10px'
          }}
        >
          {props.action != ACTIONS.VIEW && <Icon
            iconName={props.iconName}
            style={{
              color: props.iconColor,
              fontSize: 17,
              lineHeight: "44px",
            }}
          ></Icon>}
          <Icon
            iconName="PageRight"
            style={{
              color: getThemeColor("icon-color"),
              marginLeft: "20px",
              opacity:"0.9",
              fontSize: 20,
              lineHeight: "44px",
            }}
          ></Icon>
        </div>
      </div>
    )
}

export default CustomTab;